<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#485054" />
    <path
      d="M40 20.2143V19.7857C31.1429 19.5 27.1 19.2857 23.8571 16.1429C20.7143 12.9 20.4857 8.85714 20.2143 0H19.7857C19.5 8.85714 19.2857 12.9 16.1429 16.1429C12.9 19.2857 8.85714 19.5143 0 19.7857V20.2143C8.85714 20.5 12.9 20.7143 16.1429 23.8571C19.2857 27.1 19.5143 31.1429 19.7857 40H20.2143C20.5 31.1429 20.7143 27.1 23.8571 23.8571C27.1 20.7143 31.1429 20.4857 40 20.2143Z"
      fill="white"
    />
  </svg>
</template>
